import { useFetchData } from "../hooks/useFirebase";

import "./HighScores.css";

const mainClass = "HighScores";

const HighScores = () => {
  const [scores] = useFetchData();

  // const getDate = (date: any) => {
  //   const { seconds, nanoseconds } = date;
  //   const parsedDate = new Date(seconds * 1000 + nanoseconds / 1000000);
  //   return parsedDate.toDateString();
  // };

  return (
    <div className={mainClass}>
      <div className={`${mainClass}--title`}>High Scores</div>
      <ul>
        {scores.length > 0 &&
          scores.map((score: any) => (
            <li key={score.id}>
              <div className="player">{score.data.name} </div>
              <div className="points">{score.data.points} </div>
              {/* <div> {getDate(score.data.date)}</div> */}
            </li>
          ))}
      </ul>
    </div>
  );
};

export default HighScores;
